import React, { useMemo } from 'react'

import { faqPath, viewModifyCancelPath } from '@/utils'
import { IHomeType, IPageType } from '@/types'
import { Link } from '@/i18n'

export const ReservationStepsSection: React.FC<IPageType<IHomeType>> = ({
  template,
}) => {
  const steps = useMemo(
    () => [
      {
        path: viewModifyCancelPath,
        label: template.section_2_title_1,
        desc: template.section_2_description_1,
        icon: '/assets/img/find-a-reservation.png',
      },
      {
        path: faqPath,
        label: template.section_2_title_2,
        desc: template.section_2_description_2,
        icon: '/assets/img/online-check-in.png',
      },
    ],
    [template],
  )

  return (
    <section className="reservation_steps padding-vertical-regular theme--dark-blue">
      <div className="row">
        <div className="column small-12">
          <h2 className="white-color">{template.section_2_head}</h2>
        </div>
        {steps.map(step => (
          <div key={step.path} className="column small-12 medium-6">
            <div className="flex-container align-top white-color item">
              <img alt={step.label ?? ''} src={step.icon} />
              <div>
                <h3>
                  <Link style={{ color: 'white' }} href={step.path}>
                    {step.label}
                  </Link>
                </h3>
                <p>{step.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
